import Vue from 'vue'
import UserAgent from 'mobile-detect'
const ua = new UserAgent(window.navigator.userAgent)
ua.isMobile = ua.mobile()
ua.isPhone = ua.phone()
if (ua.match('DingTalk') && window.innerWidth < 500) {
  ua.isPhone = true
  ua.isMobile = true
}
Vue.prototype.$ua = ua
// console.log(ua.mobile())
export const isMobile = ua.isMobile
export const isPhone = ua.isPhone
